<template>
    <div>
        <!-- Logo/Mobile Menu Button -->
        <div class="flex items-center gap-4.5 pl-0">
          <UButton class="bg-3a-nav-btn" :class="menuColorTheme.light ? 'dark' : ''" @click="toggleMobileMenu" :title="$t('common.sidebar.open_sidebar')"
            style="z-index:51">
            <Menu class="h-3.5 w-3.5" />
          </UButton>
          <component :is="menuColorTheme.light ? LogoIconGradient : LogoIcon" class="h-8 w-auto z-51 shrink-0" :class="menuColorTheme.light ? '' : 'text-white'" style="cursor:pointer" @click="router.push('/')"/>
          <div v-if="menuColorTheme.key=='chevez'" class="w-px h-4 bg-zinc-300 ml-17.5 -mr-22  hidden sm:inline"></div>
          <p v-if="menuColorTheme.key=='chevez'" class="ml-21 -mt-1 font-bold text-2xl font-sans bg-gradient-to-r from-teal-600 to-blue-900 bg-clip-text text-transparent">
            <component :is="Logo_iQAGradient" class="h-8 w-auto z-1000 shrink-0" />
          </p>
        </div>

        <div v-if="menuColorTheme.key=='chevez'" class="main-container bg-[] hidden md:flex fixed left-0 top-0 shadow z-50 w-full h-12 items-center" >
          <div class="flex-1"></div>
          
          <div class="pseudo-navbar-option flex-1 flex justify-end pr-4">
              <UDropdownMenu  v-model:open="open" :modal="false" class='z-100' style="cursor:pointer"
                @mouseenter="open = true"
                @mouseleave="open = false"
                :items="(userMenu as any)"
                :ui="{
                  content: 'w-48 pseudo-navbar-content' + (menuColorTheme.light ? ' navbar-light' : '')
                }"
              >
                <button color="neutral" variant="outline" class="pseudo-navbar-overflown-options-button flex items-center">
                  <div class="w-8 h-8 mr-2 bg-gradient-to-l from-teal-600 to-blue-900 rounded-full flex items-center justify-center font-bold text-white">{{ nombreUsuario?.charAt(0) }}</div>
                  {{ nombreUsuario }}
                  <UIcon name="i-lucide-dot" class="text-green-500" />
                </button> 
              </UDropdownMenu>
            </div>
        </div>
        <div v-if="menuColorTheme.key!='chevez'" class="no-print main-container bg-[] hidden fixed left-0 top-0 shadow z-50 w-full h-12 justify-right" :class="menuColorTheme.light ? 'navbar-light' : ''">
          <div class="flex-1"></div>
          <div class="flex justify-center">
            <div class="flex items-center gap-1  mr-2">
              <UDropdownMenu v-if="hasPermission('inspections.create')" class='z-100 h-8.5' style="cursor:pointer" :modal="false"
                :items="(inspectionsItems.nodes.value as any)"
                :ui="{
                  content: 'max-w-100 pseudo-navbar-content' + (menuColorTheme.light ? ' navbar-light' : '')
                }"
              >
                <UButton class="pseudo-navbar-option flex items-center gap-2">
                  <UIcon name="i-lucide-scan-eye"/> 
                  {{$t('inspections.object_name_plural')}}
                  <UIcon name="i-lucide-chevron-down" />
                </UButton>
              </UDropdownMenu>
              <UDropdownMenu class=' z-100 h-8.5 2xl:mr-70' style="cursor:pointer" :modal="false"
                :items="(itemsDesktop as any)"
                :ui="{
                  content: 'max-w-100 pseudo-navbar-content' + (menuColorTheme.light ? ' navbar-light' : '')
                }"
              >
                <UButton class="pseudo-navbar-option flex items-center gap-2">
                  <UIcon name="i-lucide-folder-tree"/> 
                  {{$t('menus.object_name')}}
                  <UIcon name="i-lucide-chevron-down" />
                </UButton>
              </UDropdownMenu>
              <USelect v-if="(tenantItems.length > 1) && showTenantSelect" v-model="tenantSelectedValue" 
                :items="tenantItems" 
                option-attribute="label"
                value-attribute="value"
                class="tenantNavSelectV2 tenantNavSelect-navbar w-38 items-left" 
                :ui="{
                  content: 'text-left',
                  item: 'text-left',
                  label: 'text-left',
                  trailingIcon: 'text-white/65'
                }" 
              />
              <UDropdownMenu  v-model:open="open" :modal="false" class='pseudo-navbar-option userNavMenuButton' style="cursor:pointer"
                @mouseenter="open = true"
                @mouseleave="open = false"
                :items="(userMenu as any)"
                :ui="{
                  content: 'w-48' + (menuColorTheme.light ? ' navbar-light' : '')
                }"
              >
                <button color="neutral" variant="outline" class="pseudo-navbar-overflown-options-button flex items-center">
                  <UIcon name="i-lucide-dot" class="text-green-500 ml-0" />
                  <UIcon name="i-lucide-user-circle" /> &nbsp;
                  {{ nombreUsuario }} &nbsp;
                </button> 
              </UDropdownMenu>
              <div v-if="(tenantItems.length ==0) && showTenantSelect" 
                class="tenantNavSelect tenantNavSelect-navbar w-38 flex items-center px-2.5 py-1.5 text-sm 
                  rounded-md bg-default text-highlighted ring ring-inset ring-accented">
                {{ tenantItems[0]?.label || '—' }}
              </div>
              <!-- <button v-if="isTouchDevice" @click="toggleFullscreen" class="no-print fullscreen-button items-left" >
                <UIcon name="i-lucide-expand" style="margin-bottom:-1px" title=""/>
              </button> -->
            </div>
          </div>
        </div>
        <div v-if="isMobileMenuOpen && !menuIsPinned" class="fixed inset-0 -xs bg-opacity-50 z-40 " @click="toggleMobileMenu"></div>

        <div v-if="isMobileMenuOpen" 
          :class="[!menuIsPinned ? 'fixed top-0 left-0 h-full w-full max-w-[375px] xs:w-32 sm:w-72 md:w-72 shadow-lg z-52 transform transition-transform flex flex-col' : 
            'hidden md:flex fixed  top-0 '+(menuColorTheme.takeNav ? 'md:top-0 z-52 ':'md:top-12 md:h-[calc(100vh-3rem)]')+' left-0 h-full  w-full max-w-[375px] xs:w-32 sm:w-72 md:w-72 shadow-lg md:shadow-none z-50 transform transition-transform flex-col', '']"
          :style="{ '-webkit-backdrop-filter': 'blur(10px)', 'backdrop-filter': 'blur(8px)', background: menuColorTheme.drawer }">
            <div :class="[!menuIsPinned ? '  ':(menuColorTheme.takeNav ? '':'md:hidden'), 'pl-5 p-2 flex justify-between ']" :title="$t('common.sidebar.pin_menu')">
              
              <UButton class="bg-3a-nav-btn" :class="'z-52'" @click="toggleMobileMenu" :title="$t('common.sidebar.open_sidebar')" >
                <Menu class="h-3.5 w-3.5" />
              </UButton>
              <component :is="LogoIcon" class="h-8 w-auto  shrink-0  pl-3" :class="'text-white'" style="cursor:pointer" @click="router.push('/')"/>
        
              <span class="h-8 w-9 inline-flex" ></span>
              <button class="bg-3a-nav-btn hidden " :class="[!menuIsPinned ? ' md:inline-flex ':'md:hidden']" @click="pinMenu"  style="cursor:pointer">
                  <Pin class="h-4 w-4" />
              </button>
              <button class="bg-3a-nav-btn hidden " :class="[!menuIsPinned ? ' md:hidden ':'md:inline-flex']" @click="pinMenu"  style="cursor:pointer">
                  <PinOff class="h-4 w-4" />
              </button>
              <button class="bg-3a-nav-btn inline-flex md:hidden"  @click="toggleMobileMenu"  style="cursor:pointer">
                  <X class="h-4 w-4" />
              </button>
              <span class="h-8 w-4 inline-flex md:hidden" ></span>
            </div>
          <div class="px-4 pt-2 flex items-start pb-2 flex-shrink-0">
            <span class="text-white font-medium">
            {{ nombreUsuario }} <br />
            <small class="text-white/80">{{ email }}</small>
            </span>
          </div>
          <!-- Body (scrollable menu) -->
          <div class="menux px-4 pt-0 xs:pt-2 flex-1 overflow-y-auto overscroll-contain">
            <!-- 🔍 Search input -->
            <div class="flex">
              <USelect v-if="(tenantItems.length > 1) && showTenantSelect" v-model="tenantSelectedValue" 
                :items="tenantItems" 
                option-attribute="label"
                value-attribute="value"
                class="tenantNavSelect tenantNavSelect-menu w-full mb-2 items-left" 
                :ui="{
                  content: 'text-left',
                  item: 'text-left',
                  label: 'text-left',
                  trailingIcon: 'text-white/65'
                }" />
              <div v-if="(tenantItems.length ==0) && showTenantSelect" 
                class="tenantNavSelect tenantNavSelect-menu w-full flex items-center px-2.5 py-1.5 text-sm 
                  rounded-md bg-default text-highlighted ring ring-inset ring-accented">
                {{ tenantItems[0]?.label || '—' }}
              </div>
            </div>
            <div class="relative mb-2">
                <input
                  v-model="search"
                  type="text"
                  :placeholder="$t('common.sidebar.search')" 
                  class="w-full rounded-lg border border-white/20 bg-white/10 text-white placeholder-white/50 pl-3 pr-9 py-2 focus:outline-none focus:ring-1 focus:ring-blue-400"
                />
                <Search class="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/70" />
                <!-- Clear button -->
                <UButton
                  v-if="search"
                  icon="i-lucide-x"
                  variant="subtle"
                  @click="search = '';"
                  :title="$t('common.tooltip.clear')"
                  class="three-ac-button add absolute cursor-pointer right-8 top-1/2 -translate-y-1/2 text-red-500"
                />
            </div>
            <UNavigationMenu 
              :items="filteredItems"
              orientation="vertical"
              class="data-[orientation=vertical] text-white"
              :ui="{
                list: 'divide-y divide-white/20 mb-2',
                childList: 'border-white/20',
                childLinkDescription: 'text-balance line-clamp-2'
              }"
            >
            </UNavigationMenu>
          </div>
          <!-- Footer -->
          <div class=" items-center justify-between  px-3 pb-2 hidden sm:block">
            <div class="p-4 pb-8 flex items-center justify-center w-full">
                <button @click="logout" class="bg-3a-nav-btn flex flex-col items-center justify-center text-white hover:text-gray-200 transition">
                    <UIcon name="i-lucide-log-out" class="h-6 w-6 mb-1" />
                    <span class="text-sm">{{$t('common.sidebar.logout') }}</span>
                </button>
            </div>
            <div class="p-0 flex-shrink-0 mb-0">
                <div class="flex flex-row items-center justify-between w-full text-white hover:text-gray-200 transition text-xs">
                    
                    <ColorThemePicker
                      :themes="menuColorThemes"
                      :model-value="menuColorThemeKey"
                      :title="$t('common.sidebar.app_theme')"
                      @update:model-value="setMenuColorTheme"
                    />
                    <LanguageSwitcher />
                    <timezoneSwitcher />
                </div>
            </div>
          </div>
          <div class="flex items-center justify-between px-3 pb-2 block sm:hidden">
            <div class="flex-shrink-0">
              <UButton @click="logout" class="bg-3a-nav-btn flex  items-center justify-center w-full text-white hover:text-gray-200 transition">
                  <LogOut class="h-4 w-4 mr-2" style="margin-top:2px" />
                  <span class="text-sm">{{$t('common.sidebar.logout') }}</span>
              </UButton>
            </div>
            <div class="p-0 flex-shrink-0 mb-0">
              <div class="flex flex-col items-center justify-center w-full text-white hover:text-gray-200 transition text-xs">
                  <languageSwitcher />
              </div>
            </div>
            <div class="p-0 flex-shrink-0 mb-0">
              <div class="flex flex-col items-center justify-center w-full text-white hover:text-gray-200 transition text-xs">
                  <timezoneSwitcher />
              </div>
            </div>
            <div class="p-0 flex-shrink-0 mb-0">
              <div class="flex flex-col items-center justify-center w-full text-white hover:text-gray-200 transition text-xs">
                  <ColorThemePicker
                    :themes="menuColorThemes"
                    :model-value="menuColorThemeKey"
                    :title="$t('common.sidebar.app_theme')"
                    @update:model-value="setMenuColorTheme"
                  />
              </div>
            </div>
          </div>
        </div>

    
    <UModal :dismissible="false" 
      v-model:open="(inspectionsItems.openInspectionBatchForm.value as boolean)" 
      :title="$t('inspection_batches.create_window_title')"
      :description="$t('inspection_batches.create_window_subtitle')"
      :ui="{ footer: 'justify-end', overlay: 'bg-black/25 backdrop-blur-xs' }"
    >
      <template #body >
        <CatalogsInspectionBatchHeader
          ref="childRef"
          :id="String('')"
          :inspection-template-id="(inspectionsItems.selectedInspectionId.value || 0 as number)"
          :inspection-template-name="(inspectionsItems.selectedInspectionName.value || '')"
          :isUpdate="false"
          :isReadOnly="false" />
      </template>

      <template #footer>
        <UButton :label="$t('common.action.cancel')" color="neutral" variant="outline" @click="inspectionsItems.openInspectionBatchForm.value = false;" />
        <UButton class="color-green-100" @click="handleSubmit()" style="vertical-align:center">
          {{ $t('common.action.continue') }} <UIcon name="i-lucide-chevron-right" title=""/>
        </UButton>
      </template>
    </UModal>

    <UModal :dismissible="false"
      v-model:open="(inspectionsItems.openInspectionRex3Form.value as boolean)"
      :title="$t('inspection_rex3.create_window_title')"
      :description="$t('inspection_rex3.create_window_subtitle')"
      :ui="{ footer: 'justify-end', overlay: 'bg-black/25 backdrop-blur-xs' }"
    >
      <template #body >
        <CatalogsInspectionRex3Header 
          ref="childRef"
          :id="String('')"
          :inspection-template-id="(inspectionsItems.selectedInspectionId.value || 0 as number)"
          :inspection-template-name="(inspectionsItems.selectedInspectionName.value || '')"
          :isUpdate="false"
          :isReadOnly="false" />
      </template>

      <template #footer>
        <UButton :label="$t('common.action.cancel')" color="neutral" variant="outline" @click="inspectionsItems.openInspectionRex3Form.value = false;" />
        <UButton class="color-green-100" @click="handleSubmit()" style="vertical-align:center">
          {{ $t('common.action.continue') }} <UIcon name="i-lucide-chevron-right" title=""/>
        </UButton>
      </template>
    </UModal>

    
    <UModal :dismissible="false" 
      v-model:open="(inspectionsItems.openInspectionOpenCellForm.value as boolean)" 
      :title="$t('inspection_open_cell.create_window_title')"
      :description="$t('inspection_open_cell.create_window_subtitle')"
      :ui="{ footer: 'justify-end', overlay: 'bg-black/25 backdrop-blur-xs' }"
    >
      <template #body >
        <CatalogsInspectionOpenCellHeader 
          ref="childRef"
          :id="String('')"
          :inspection-template-id="(inspectionsItems.selectedInspectionId.value || 0 as number)"
          :inspection-template-name="(inspectionsItems.selectedInspectionName.value || '')"
          :isUpdate="false"
          :isReadOnly="false" />
      </template>

      <template #footer>
        <UButton :label="$t('common.action.cancel')" color="neutral" variant="outline" @click="inspectionsItems.openInspectionOpenCellForm.value = false;" />
        <UButton class="color-green-100" @click="handleSubmit()" style="vertical-align:center">
          {{ $t('common.action.continue') }} <UIcon name="i-lucide-chevron-right" title=""/>
        </UButton>
      </template>
    </UModal>

    <!-- Drawer de procesos CheckR: se abre desde la opcion AI Inspections del menu. -->
    <CatalogsCheckrProcessDrawer v-model:open="checkrDrawerOpen" @select="goToCheckrProcess" />

    <!-- Registro de Producto No Conforme: se abre desde la opcion del menu y desde el reporte. -->
    <UModal :dismissible="false"
      v-model:open="nonConformingProductDialogOpen"
      :title="$t('non_conforming_products.create_window_title')"
      :description="$t('non_conforming_products.create_window_subtitle')"
      :ui="{ footer: 'justify-end', overlay: 'bg-black/25 backdrop-blur-xs' }"
    >
      <template #body>
        <CatalogsNonConformingProduct ref="nonConformingProductRef" />
      </template>
      <template #footer>
        <UButton :label="$t('common.action.cancel')" color="neutral" variant="outline" @click="nonConformingProductDialogOpen = false" />
        <UButton :label="$t('common.action.save')" class="btn-save" @click="submitNonConformingProduct()" />
      </template>
    </UModal>
    </div>
</template>
<script setup lang="ts">
const { t: $t } = useI18n()

import type { NavigationMenuItem } from '@nuxt/ui';
import { useAttrs } from 'vue'
import LogoIcon from '~/assets/3a-logo-core-materials.svg'
import LogoIconGradient from '~/assets/3a-logo-core-materials-gradient.svg'
import Logo_iQA from '~/assets/iQA/iqa_logo.svg'
import Logo_iQAGradient from '~/assets/iQA/iqa_logo_gradient.svg'
import { ref } from 'vue';
import { useAuthStore } from '~/stores/auth'
import { X, LogOut, Search, Menu, Pin, PinOff } from 'lucide-vue-next'
import Tree from 'primevue/tree'
import type { Tenant } from '~/types/tenant'
import { useTenant } from '~/composables/auth/useTenant'
import ColorThemePicker from './ColorThemePicker.vue'

const { locale } = useI18n()

const router = useRouter()
const open = ref(false)
const childRef = ref();
const { hasPermission } = usePermissions();
const { theme: menuColorTheme, themeKey: menuColorThemeKey, setMenuColorTheme, themes: menuColorThemes } = useMenuColorTheme();

const props = defineProps<{
  menuStyle?: string,
  navbarStyle?: string
}>();

const { menuStyle, navbarStyle } = props

interface TreeNode {
  label: string
  key: string
  children?: TreeNode[]
}

//const items = ref(await useMenuItems(locale.value))
const items = useMenuItems($t,locale);
const search = ref('')
// función recursiva para filtrar
function filterNodes(nodes: any[], term: string): any[] {
  const lower = term.toLowerCase()

  return nodes.reduce((acc: any[], node) => {
    const match = node.label.toLowerCase().includes(lower)

    let filteredChildren = []
    if (node.children) {
      filteredChildren = filterNodes(node.children, term)
    }

    if (match || filteredChildren.length > 0) {
      // ⚠️ solo clonamos si cambia children
      if (filteredChildren.length !== (node.children?.length ?? 0)) {
        acc.push({
          ...node,
          children: filteredChildren
        })
      } else {
        acc.push(node) // 👈 misma referencia
      }
    }

    return acc
  }, [])
}

//Inspection options
const allowHidden = ref(true);
const inspectionsItems  = useDataEntryTree(allowHidden.value,locale,'iqa-data-entry-tree-cache');

watch(inspectionsItems.selectedNodes, (newSelection) => {
}, { deep: true });

// La opcion "AI Inspections" no navega: abre el drawer de procesos CheckR (que a su vez
// tiene un boton para ir a la pantalla). Se aplica sobre una copia, el resto del sistema
// (p.ej. IndexList) sigue viendo el item con su ruta.
const { open: checkrDrawerOpen } = useCheckrProcessDrawer();
function goToCheckrProcess(process: { processId: string }) {
  checkrDrawerOpen.value = false;
  navigateTo({ path: AI_INSPECTIONS_PATH, query: { checkrProcessId: process.processId } });
}
// "Producto No Conforme" tampoco navega: abre el dialogo de registro.
const { open: nonConformingProductDialogOpen, lastCreatedAt: nonConformingProductLastCreatedAt } = useNonConformingProductDialog();
const nonConformingProductRef = ref();
async function submitNonConformingProduct() {
  const response = await nonConformingProductRef.value?.submitForm();
  if (!response?.success) return;
  nonConformingProductDialogOpen.value = false;
  nonConformingProductLastCreatedAt.value = Date.now();
  await swal_success(response.message);
}
function withCheckrDrawer(nodes: any[]): any[] {
  return nodes.map(node => {
    if (node.code === 'inspection-ai')
      return { ...node, to: undefined, onSelect: () => { checkrDrawerOpen.value = true } };
    if (node.code === NON_CONFORMING_PRODUCT_REGISTRATION_CODE)
      return { ...node, to: undefined, onSelect: () => { nonConformingProductDialogOpen.value = true } };
    return node.children ? { ...node, children: withCheckrDrawer(node.children) } : node;
  });
}

// computed reactivo para el resultado
const filteredItems = computed(() => {
  if (!search.value) return withCheckrDrawer(items.value)
  return withCheckrDrawer(filterNodes(items.value, search.value))
})

const nodes = ref<any[]>([])

watchEffect(async () => {
  const items = useMenuItems($t,locale);
  nodes.value = items.value
})

const userData = JSON.parse(localStorage.getItem("iqa-auth") || "{}")

//Tenants Select
const tenantOptions = userData?.user?.tenants;
const savedTenant = JSON.parse(localStorage.getItem("iqa-auth") || '""').selectedTenant;
const tenantSelectedValue = ref(savedTenant.value)

watch(tenantSelectedValue, async (val) => {
  const tenantObj = tenantItems.value.find(t => t.value === val)
  if (tenantObj) {
    const { selectTenant } = useTenant();
    const authStore = useAuthStore();
    const userCredentials = authStore.user;
    if (!userCredentials) return;

    await selectTenant(tenantObj.code, userCredentials);
    window.location.reload();
  }
})

const tenantItems = ref<{ label: string; value: string; code: string; picture: string; logo: string }[]>([])
tenantItems.value = [
  ...( tenantOptions as any )
  .filter((tenant: Tenant) => tenant.isActive)
  .map((tenant: Tenant) => ({
      label: tenant.name,
      value: tenant.id, 
      code: tenant.code
  }))
];
//Tenants Select.

const itemsDesktop = ref<NavigationMenuItem[]>([]);
const userMenu = ref<NavigationMenuItem[]>([]);

const nombreUsuario = userData.user.firstName + " " + userData.user.lastName || 'usuario';
const email = userData.user.email || '';

const menuIsPinned = useMenuPinned();
watch(menuIsPinned, (val) => {
  localStorage.setItem('iqa-menu-pinned', String(val));
});
const isMobileMenuOpen = ref(menuIsPinned.value); // arranca abierto si estaba pinned

const pinMenu = () => {
    menuIsPinned.value = !menuIsPinned.value;
}; 
const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value;
    if( !isMobileMenuOpen.value)
      menuIsPinned.value = false;
}; 
const showTenantSelect = ref(true);

watchEffect(async () => {
    buildMenu();
})
const isTouchDevice = ref(null)
onMounted(() => {  
  ////verificar si es dispostivo tactil
  isTouchDevice.value =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0;

  document.body.classList.toggle('touch-device', isTouchDevice.value);
  
  document.addEventListener('fullscreenchange', updateFullscreenState)
  updateFullscreenState()
  buildMenu();
  //observeBreadcrumb();
  //window.addEventListener('resize', observeBreadcrumb);
  //document.addEventListener('mousedown', handleClickOutside)
});

onBeforeUnmount(() => {
  //document.removeEventListener('mousedown', handleClickOutside)
  document.removeEventListener('fullscreenchange', updateFullscreenState)
})
 
const isFullscreen = ref(false)

function updateFullscreenState() {
  isFullscreen.value = !!document.fullscreenElement
}

async function toggleFullscreen() {

  try {
    if (document.fullscreenElement) {
      await document.exitFullscreen()
    } else {
      await document.documentElement.requestFullscreen()
    }
  } catch (error) {
    console.error(error)
  }
  
}


async function buildMenu()
{
    //let menuItems = await useMenuItems($t,locale);
    //items.value = menuItems;
    itemsDesktop.value = withCheckrDrawer(removeOpen(items.value)) as NavigationMenuItem[]
    const isDesktop = window.matchMedia('(min-width: 900px)').matches;

    const mq = window.matchMedia('(min-width: 900px)');
    const userMenuItem = 
      {
        id: 'userOptionLogout',
        label: $t('common.top_navbar.logout_menu'),
        icon: 'i-lucide-log-out',
        orientation: 'vertical',
        description: $t('common.top_navbar.logout_menu_subtitle'),
        onSelect: () => logout(),
        to: "/"
      };
    const apply = () => {
      if (mq.matches) {
        
        // agregar si no existe
        if (!userMenu.value.some(i => i.id === "userOptionLogout")) {
          userMenu.value.push(userMenuItem);
        }

        // agregar si no existe
        if (!itemsDesktop.value.some(i => i.id === "nombreUsuario")) {
          itemsDesktop.value.push({
            class: 'hidden',
            icon: 'i-lucide-circle-user',
            id: 'nombreUsuario',
            orientation: 'vertical',
            children: [
              {
                label: $t('common.top_navbar.logout_menu'),
                icon: 'i-lucide-log-out',
                orientation: 'vertical',
                description: $t('common.top_navbar.logout_menu_subtitle'),
                to: "/"
              }
            ]
          });
        }
      } else {
        // remover si baja de 900px
        // itemsDesktop.value = itemsDesktop.value.filter(i => i.id !== 'nombreUsuario');
      }
    }
    mq.addEventListener('change', apply);
    apply();
}

function removeOpen(nodes: any[]): any[] {
  return nodes.map(({ open, children, ...node }) => ({
    ...node,
    children: children ? removeOpen(children) : undefined
  }))
}

const emit = defineEmits<{
  (e: 'select', item: NavigationMenuItem): void
}>()

async function logout(){
    useAuthStore().logout()
    await nextTick();
    navigateTo('/login') // or use `useRouter().push('/login')`
}
const getColSpan = (i: number) => {
  // indexes 0 and 1 span full width (1 column), rest span half width (2 per row)
  switch(i){
    case 0 : case 1 : case 3 :  return 'col-span-1';
    case 2 : return 'col-span-1';
    default: return 'col-span-1';
    
  } 
};
const getColWidth = (i: number) => {
  // indexes 0 and 1 span full width (1 column), rest span half width (2 per row)
  switch(i){
    case 0 : case 1 : case 3 :  return '600';
    case 2 : return '600';
    default: return '600';
    
  } 
};

let breadcrumbObserver: IntersectionObserver | null = null;

async function handleSubmit()
{
  //addInspectionContinued(node?.id);
  //return false;
  if (!childRef.value?.submitForm)
  {
    //si el componente hijo tiene un await fuera del onmount, puede provocar que
    //el submitForm esté como no disponible
    console.warn('[Parent] submitForm is not yet available.')
    return
  } 
  
  //Now safe to call after rendering
  const response = await childRef.value?.submitForm();

  if(response.success)
  {
    await swal_success(response.message);
    swal_loading();
    if(inspectionsItems.openInspectionRex3Form.value)
    {
      let newInspectionId = response.data.id;
      inspectionsItems.openInspectionRex3Form.value = false;
      router.push("/modules/data-entry/inspection-rex3/form/edit/"+String(newInspectionId));
    }
    else if(inspectionsItems.openInspectionOpenCellForm.value)
    {
      let newInspectionId = response.data.id;
      inspectionsItems.openInspectionOpenCellForm.value = false;
      router.push("/modules/data-entry/inspection-open-cell/form/edit/"+String(newInspectionId));
    }
    else if(inspectionsItems.openInspectionBatchForm.value)
    {
      let newInspectionId = response.data.id;
      inspectionsItems.openInspectionBatchForm.value = false;
      router.push("/modules/data-entry/inspection-batches/form/edit/"+String(newInspectionId));
    }
  }
  return false; 
}
</script>
<style >


nav > div > ul > li > a > span.i-lucide\:home {
  background-color: white !important;
}
nav > div > div > div > ul > li > a > span {
  margin-top:3px /* alínea los iconos en los submenús */
}
nav > div > ul > li > a > span {
  color: white !important;
}
nav > div > ul > li > a.text-primary {
  background: linear-gradient(180deg,rgba(0, 119, 188, 1) 0%, rgba(38, 39, 114, 1) 68%);-webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;  /*fallback */
}
nav > div > ul > li > a.text-primary > span.i-lucide\:home {
  background-color: rgba(38, 39, 114, 1) !important;
}

/* Cabecera clara (temas con light:true): el texto e iconos del menú de escritorio pasan a oscuro */
.navbar-light nav > div > ul > li > a > span {
  color: #262772 !important;
}
.navbar-light nav > div > ul > li > a > span.i-lucide\:home {
  background-color: #262772 !important;
}

.pseudo-navbar-option .navbar-light{
  color:black;
}

nav.navbar > div > ul > li > a.text-primary > span.iconify,
nav.navbar > div > ul > li > a.text-primary > span,
nav.navbar > div >div >div > ul > li > a > span,
nav.navbar > div >div >div > ul > li > a,
nav.navbar > div >div >div > ul > li > button > span  {
    color: rgba(38, 39, 114, 1);
}
@media (min-width: 670px) {
  .main-container {
    display: flex;
    justify-content: right !important; /* default */
  }
}
@media (max-width: 840px) {
  .userNavMenuButton {
    display: none !important;
  }
}

@media (max-width: 1179px) {
  .main-container {
    justify-content: right !important;
  }
}

.tenantNavSelectV2 {
  outline: none !important;
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.043);
  
  border: 1px solid rgba(255, 255, 255, 0.155);
  border-radius: 8px;

  background: rgba(255, 255, 255, 0.10);

  color: #ffffff !important;
  font-size: 14px;
  cursor: pointer;

  transition: background .15s ease,
              border-color .15s ease,
              box-shadow .15s ease;
}

.tenantNavSelect {
  outline: none !important;

  border: 1px solid rgba(255,255,255,.16);
  border-radius: 8px;

  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.13) 0%,
      rgba(255, 255, 255, 0.048) 100%
  );

  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);

  color: white;

  box-shadow:
      inset 0 1px 0 rgba(255,255,255,.08),
      0 0 0 1px rgba(96,165,250,.04);

  transition: .15s ease;
}
.tenantNavSelect:hover {
  outline: none !important;
  background: rgba(255,255,255,.14);
  border-color: rgba(255, 255, 255, 0.055);
}

.tenantNavSelect:focus,
.tenantNavSelect:focus-within {
  outline: none;
  border-color: rgba(96, 165, 250, 0.311); /* blue-400 */
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.043);
}
.tenantNavSelect ::placeholder {
    color: rgba(255,255,255,.50);
}



.fullscreen-button {
  outline: none !important;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.15),
              inset 0 0 0 1px rgba(0,0,0,0.1);
  border: 1px solid #ffffff38;
  border-radius: 4px;
  background: #ff000029;
  color: white;
  font-size:14px;
  cursor:pointer;
  transition: all 0.1s ease;
  height:33px;
  width:33px;
  margin-left:1px;
}
.fullscreen-button:hover {
  outline: none;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.15),
              inset 0 0 0 1px rgba(0,0,0,0.1);
  background: #ffffff24;
  border-color: #227ac561;
}

@media (max-width: 430px) {
  .fullscreen-button {
    display: none;
  }
  .tenantNavSelect.tenantNavSelect-navbar{
    display: none;
  }
}
@media (min-width: 669px) {
  .tenantNavSelect.tenantNavSelect-menu{
    display: none;
  }
}

@media (min-width: 800px) and (max-width: 1180px) {
}

@media (min-width: 800px) and (max-width: 1023px) {
}

@media (max-width: 670px) {
  .pseudo-navbar-option{
    display:none !important;
  }
}

.pseudo-navbar-option{
  cursor:pointer;
  background-color:transparent ;
  font-size:14px;
  font-weight:500;
  display:flex;
  vertical-align:center;
  padding:5px 5px 5px 8px;
  min-width:40px;
  white-space: nowrap;
}
.pseudo-navbar-option:hover{
  background-color:#ffffff75;
  padding:6px 5px 6px 8px;
  border-radius:5px;
}
</style>